import { Col, Form, Row, Select } from "antd";
import { useAddressHelper } from "utils/useAddressHelper";
import { FormInstance } from "antd/es/form"; 

const { Option } = Select;


interface PermanentAddressFormProps {
  form: FormInstance;
}

const PermanentAddressForm: React.FC<PermanentAddressFormProps> = ({ form }) => {
  const {
    address,
    setAddress,
    getProvinceOptions,
    getDistrictOptions,
    getMunicipalityOptions,
    getWardOptions,
  } = useAddressHelper();

  return (
    <Row gutter={[48, 32]}>
      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
        <Form.Item
          label="Province"
          name={["permanentAddress", "province"]}
          rules={[
            {
              required: true,
              message: "This is required",
            },
          ]}
        >
          <Select
            allowClear
            placeholder="Select province"
            options={getProvinceOptions()}
            onChange={(value: string) => setAddress({ ...address, province: value },)}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
        <Form.Item
          name={["permanentAddress", "district"]}
          label="District"
          rules={[
            {
              required: true,
              message: "This is required",
            },
          ]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Select district"
            style={{ width: "100%" }}
            optionFilterProp="children"
            filterOption={(input, option: any) => {
              return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
            onChange={(value: string) => {
              setAddress({ ...address, district: value });
            }}
          >
            {getDistrictOptions()?.map((district) => (
              <Option key={district?.label} value={district?.label}>
                {district?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
        <Form.Item
          name={["permanentAddress", "municipality"]}
          label="Municipality"
          rules={[
            {
              required: true,
              message: "This is required",
            },
          ]}
        >
          <Select
            allowClear
            showSearch
            placeholder="Select municipality"
            style={{ width: "100%" }}
            optionFilterProp="children"
            filterOption={(input, option: any) => {
              return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
            }}
            onChange={(value: string) => setAddress({ ...address, municipality: value })}
          
          >
            {getMunicipalityOptions()?.map((municipality) => (
              <Option key={municipality?.label} value={municipality?.label}>
                {municipality?.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
        <Form.Item
          name={["permanentAddress", "ward"]}
          label="Ward"
          rules={[
            {
              required: true,
              message: "This is required",
            },
          ]}
        >
          <Select
            allowClear
            placeholder="Select ward"
            options={getWardOptions()}
            style={{ width: "100%" }}
          />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default PermanentAddressForm;
